import React, {useEffect, useState} from 'react';

interface AppState {
  screenSize: [number, number];
  customNavElement: React.ReactNode | null;
  setCustomNavElement: React.Dispatch<React.SetStateAction<React.ReactNode | null>>;
}

export const AppContext = React.createContext<AppState>(null as any);

export const AppContextProvider = ({children}: {children: React.ReactNode}) => {
  const [screenSize, setScreenSize] = useState<[number, number]>([0, 0]);
  const [customNavElement, setCustomNavElement] = useState<React.ReactNode | null>(null);

  useEffect(() => {
    const navBarHeight =
      parseInt(window.getComputedStyle(document.body).getPropertyValue('--nav-bar-height'), 10) + 1;

    const handleResize = () => setScreenSize(getScreenSize(navBarHeight));
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <AppContext.Provider value={{screenSize, customNavElement, setCustomNavElement}}>
      {children}
    </AppContext.Provider>
  );
};

const getScreenSize = (navBarHeight: number): [number, number] => [
  window.innerWidth,
  Math.max(0, window.innerHeight - navBarHeight),
];
